import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import Swiper, { Navigation, Autoplay, Pagination, Mousewheel, FreeMode } from 'swiper';

// Init Alpine
window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.start();

// Initialize all swipers
// 'SwipersConfig' is defined in 'head.php', every swiper block adds its config in it.
var Swipers = [];
for (sel in SwipersConfig) {
	document.querySelectorAll(`${sel} .swiper-container, ${sel} .swiper`).forEach((container) => {
		Swipers.push(
			new Swiper(container, {
				// include modules
				modules: [Navigation, Autoplay, Pagination, Mousewheel, FreeMode],
				// enable mouse-wheel by default
				mousewheel: { forceToAxis: true },
				// include swiper-specific config
				...SwipersConfig[sel],
			})
		);
	});
}
window.Swipers = Swipers;
